import { postData, getData, putData, } from '../axiosServices'


export const getAllModules = () => {
    let url = 'makermodules'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getAllTopicsData = () => {
    let url = 'topics'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const getAllTopicsOfModule = (moduleId) => {
    let url = `topics/${moduleId}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers })
}
export const addModule = (formData) => {
    const url = 'makermodules';
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, formData, { headers });
}
export const updateModule = (id, data) => {
    let url = `makermodules/${id}`
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers })
}
export const addTopic = (id, formData) => {
    const url = `topics/${id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    };
    return postData(url, formData, { headers });
}
export const updateTopic = (topic_id, module_id, data) => {
    const url = `topics/${topic_id}/module/${module_id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers })
}
export const disableTopic = (topic_id, module_id,) => {
    const url = `topics/${topic_id}/module/${module_id}/isdisable`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, {}, { headers })
}
export const disableModule = (module_id,) => {
    const url = `makermodules/${module_id}/isdisable`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, {}, { headers })
}
